import * as React from 'react'

/**
 * Wstrzykuje stałe propsy-funkcje do komponentu klasowego.
 *
 * Zastępuje `connect(null, mapDispatchToProps)` w miejscach, gdzie mapowanie i tak
 * już nie dotykało reduxa - zostały w nim zwykłe wywołania API. Obiekt liczymy raz,
 * bo to same funkcje modułowe; przy `connect` powstawał na nowo przy każdym renderze.
 *
 * Przepuszcza ref, bo panel administracyjny sięga po instancję zakładki (wcześniej przez `withRef`
 * i `getWrappedInstance()` z `connect`).
 */
export function withActions<P extends object, A extends object>(
  Wrapped: React.ComponentType<P>,
  actions: A,
) {
  const WithActions = React.forwardRef<unknown, Omit<P, keyof A>>(
    (props, ref) => (
      <Wrapped ref={ref as any} {...(props as unknown as P)} {...(actions as any)} />
    ),
  )

  WithActions.displayName = `withActions(${
    (Wrapped as any).displayName || (Wrapped as any).name || 'Component'
  })`

  return WithActions
}
